import { useEffect, useState } from "react";
import Widget from "components/widget/Widget";
import {
  MdPeople,
  MdSchool,
  MdCalendarMonth,
  MdSupervisorAccount,
  MdSportsKabaddi,
  MdPerson,
  MdAdminPanelSettings,
} from "react-icons/md";
import { getDashboardStats, DashboardStats } from "services/admin/statisticsService";
import { useLanguage } from "context/LanguageContext";

const ManagerDashboard = () => {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const { t } = useLanguage();

  useEffect(() => {
    getDashboardStats().then(setStats).catch(console.error);
  }, []);

  if (!stats) return null;

  return (
    <div>
      <h2 className="mb-4 text-2xl font-bold text-ink">
        {t("dashboard.centerStats")}
      </h2>
      <div className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <Widget
          tone="brand"
          icon={<MdPeople className="h-7 w-7" />}
          title={t("dashboard.totalUsers")}
          subtitle={String(stats.total_users)}
        />
        <Widget
          tone="success"
          icon={<MdSupervisorAccount className="h-7 w-7" />}
          title={t("dashboard.totalStudents")}
          subtitle={String(stats.total_students)}
        />
        <Widget
          tone="teal"
          icon={<MdSportsKabaddi className="h-7 w-7" />}
          title={t("dashboard.totalTrainers")}
          subtitle={String(stats.total_trainers)}
        />
        <Widget
          tone="info"
          icon={<MdPerson className="h-7 w-7" />}
          title={t("dashboard.totalTeachers")}
          subtitle={String(stats.total_teachers)}
        />
        <Widget
          tone="purple"
          icon={<MdAdminPanelSettings className="h-7 w-7" />}
          title={t("dashboard.totalManagers")}
          subtitle={String(stats.total_managers)}
        />
        <Widget
          tone="warning"
          icon={<MdSchool className="h-7 w-7" />}
          title={t("dashboard.totalClasses")}
          subtitle={String(stats.total_classes)}
        />
        <Widget
          tone="brand"
          icon={<MdCalendarMonth className="h-7 w-7" />}
          title={t("dashboard.totalSessions")}
          subtitle={String(stats.total_sessions)}
        />
      </div>
    </div>
  );
};

export default ManagerDashboard;
